import React from 'react';

import { createPageLayout } from '@opengov/app-core/layout';

import { getModalComponent } from '../../../application/common/modals';
import { useReportingErpModeAgentContext } from './useReportingErpModeAgentContext';

const PageLayout = createPageLayout(getModalComponent);

type ReportPageProps = React.ComponentProps<typeof PageLayout>;

// BUD-20265: every Reporting page renders through this layout, so this is the one place the
// `reporting_erp_mode` OG Assist context element is contributed from.
export const ReportPage: React.FC<ReportPageProps> = (props) => {
  const agentApplicationContext = useReportingErpModeAgentContext();

  return <PageLayout {...props} agentApplicationContext={agentApplicationContext} />;
};

ReportPage.displayName = 'ReportPage';
